import * as React from 'react';
import { useSelector } from 'react-redux';

import { Advantages } from '../../components/Advantages/Advantages';
import { TabView } from '../../components/Advantages/internal/components/TabView';
import { useUpdateEffect } from '@cian/react-utils';
import { getTemplateSpecialPromoAdvantages } from '../../selectors/developerV2/templateSpecialPromo/getTemplateSpecialPromoAdvantages';

export const AdvantagesTemplateSpecialPromoContainer: React.FC = () => {
  const advantages = useSelector(getTemplateSpecialPromoAdvantages);
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);

  useUpdateEffect(() => {
    setActiveTabIndex(0);
  }, [advantages?.advantages.length]);

  if (!advantages?.advantages.length || !(activeTabIndex in advantages.advantages)) {
    return null;
  }

  const activeTabData = advantages.advantages[activeTabIndex];

  return (
    <Advantages
      title={advantages.header}
      activeTabView={<TabView description={activeTabData.description} imageUrl={activeTabData.image.url} />}
      tabItems={advantages.advantages.map(({ name }) => ({ text: name }))}
      description={advantages.description}
      activeTabIndex={activeTabIndex}
      onTabClick={setActiveTabIndex}
    />
  );
};
